











import { Component , Vue } from 'vue-property-decorator';
declare var $: any;
@Component({
    props: {
        title: String,
        message: String,
        closeTitle: {
            type: String,
            default: 'Ok',
        },
    },
})
export default class MessageBox extends Vue {

    private handleOk() {
        $('#messageBox').modal('hide');
        this.$emit('ok');
    }
    private showModal() {
      this.$root.$emit('bv::show::modal', 'messageModal', '#messageBox');
    }
}
